import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M25 31c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5ZM15.579 5.575l.85 17A1.5 1.5 0 0 0 17.927 24h4.146a1.5 1.5 0 0 0 1.498-1.425l.85-17A1.5 1.5 0 0 0 22.923 4h-5.846a1.5 1.5 0 0 0-1.498 1.575Z" })
});
export default SvgExclamation;
